import { render, staticRenderFns } from "./jihua_list.vue?vue&type=template&id=3116f339&scoped=true&"
import script from "./jihua_list.vue?vue&type=script&lang=js&"
export * from "./jihua_list.vue?vue&type=script&lang=js&"
import style0 from "./jihua_list.vue?vue&type=style&index=0&id=3116f339&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3116f339",
  null
  
)

export default component.exports